import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { APP_ROUTES } from '../constants/app-routes';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    
    if (this.authService.isLoggedIn()) {
      return true;
    }
  
    this.router.navigate(['/', APP_ROUTES.auth.base, APP_ROUTES.auth.login], { queryParams: { returnUrl: state.url } });
    return false;
  }
}